import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CaseStudiesHero from './components/CaseStudiesHero';
import CaseStudiesGrid from './components/CaseStudiesGrid';
import CaseStudiesCTA from './components/CaseStudiesCTA';

export default function CaseStudies() {
  return (
    <div className="min-h-screen bg-slate-950">
      <Navbar />
      <CaseStudiesHero />
      <CaseStudiesGrid />
      <CaseStudiesCTA />
      <Footer />
    </div>
  );
}
